import React, { useState, Fragment } from 'react';
import {
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Collapse,
  Card,
  CardBody,
  CardTitle,
  Input,
  Label,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
  faCommentDots,
  faEdit,
  faTrashAlt,
  faLaptopCode,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function GoToResponse({
  dialogUpdate,
  elem,
  dialogIndex,
  codeIndex,
  message,
  dialogNames,
}) {
  const [isEditing, setIsEditing] = useState(false);
  const [messageInput, setMessageInput] = useState(message);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [postData, setPostData] = useState(elem);
  const handleEdit = () => {
    setIsEditing(true);
  };
  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };
  const handleDelete = () => {
    const data = { ...postData };
    data.messages.splice(codeIndex, 1);
    dialogUpdate(postData, dialogIndex);
    toggle();
  };
  const handleTextChange = (e) => {
    setMessageInput({
      ...messageInput,
      [e.target.name]: e.target.value,
    });
  };
  const handleSave = () => {
    const data = { ...postData };
    if (messageInput.target !== '') {
      data.messages[codeIndex].target = messageInput.target;
    } else {
      if (data.messages[codeIndex].target) {
        delete data.messages[codeIndex].target;
      }
    }
    if (messageInput.comp !== '') {
      data.messages[codeIndex].comp = messageInput.comp;
    } else {
      if (data.messages[codeIndex].comp) {
        delete data.messages[codeIndex].comp;
      }
    }
    if (messageInput.compA !== '') {
      data.messages[codeIndex].compA = messageInput.compA;
    } else {
      if (data.messages[codeIndex].compA) {
        delete data.messages[codeIndex].compA;
      }
    }
    if (messageInput.compB !== '') {
      data.messages[codeIndex].compB = messageInput.compB;
    } else {
      if (data.messages[codeIndex].compB) {
        delete data.messages[codeIndex].compB;
      }
    }

    dialogUpdate(data, dialogIndex);
    setIsEditing(false);
  };
  const handleCancel = () => {
    setIsEditing(false);
    setMessageInput(message);
  };
  return (
    <Card className="mb-2">
      <CardBody>
        {isEditing ? (
          <Fragment>
            {' '}
            <CardTitle>
              <Row>
                {/* <pre>{JSON.stringify(postData, null, 2)}</pre> */}
                <Colxx xxs="6">
                  <FontAwesomeIcon icon={faCommentDots} />
                  <span> </span>
                  Go To
                </Colxx>
                <Colxx xxs="6">
                  <div className="float-right">
                    <Button
                      color="primary"
                      className="add-button"
                      size="xs"
                      onClick={handleSave}
                    >
                      Save
                    </Button>
                    <b> </b>
                    <Button
                      color="secondary"
                      className="add-button"
                      size="xs"
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                  </div>
                </Colxx>
              </Row>{' '}
            </CardTitle>
            <Row className="mb-2">
              <Colxx xxs="4">
                <Label>Compare A</Label>
                <Input
                  type="text"
                  value={messageInput.compA ? messageInput.compA : ''}
                  onChange={handleTextChange}
                  name="compA"
                />
              </Colxx>
              <Colxx xxs="4">
                <Label>Equation</Label>
                <Input
                  type="select"
                  value={messageInput.comp ? messageInput.comp : ''}
                  onChange={handleTextChange}
                  name="comp"
                >
                  {' '}
                  <option value={''}>Please Select</option>
                  <option value={'EQUAL'}>EQUAL</option>
                  <option value={'TRUE'}>TRUE</option>
                  <option value={'FALSE'}>FALSE</option>
                </Input>
              </Colxx>
              <Colxx xxs="4">
                <Label>Compare B</Label>
                <Input
                  type="text"
                  value={messageInput.compB ? messageInput.compB : ''}
                  onChange={handleTextChange}
                  name="compB"
                />
              </Colxx>
            </Row>
            <Row>
              <Colxx xxs="12" className="mb-2">
                <Label>Go To: Select or Type</Label>
                <Input
                  type="select"
                  value={messageInput.target ? messageInput.target : ''}
                  onChange={handleTextChange}
                  name="target"
                >
                  <option value={''}>Please Select</option>
                  {dialogNames.map((name) => {
                    return <option value={name}>{name}</option>;
                  })}
                </Input>
              </Colxx>
              <Colxx xxs="12" className="mb-2">
                -OR-
              </Colxx>
              <Colxx xxs="12" className="mb-2">
                <Input
                  type="text"
                  defaultValue={messageInput.target ? messageInput.target : ''}
                  onChange={handleTextChange}
                  name="target"
                />
              </Colxx>
            </Row>
          </Fragment>
        ) : (
          <Fragment>
            <CardTitle>
              <Row>
                <Colxx xxs="8">
                  <FontAwesomeIcon icon={faCommentDots} />
                  <span> </span>
                  Go To
                </Colxx>
                <Colxx xxs="4">
                  <div className="float-right">
                    <FontAwesomeIcon
                      icon={faEdit}
                      color="#90caf9"
                      cursor="pointer"
                      onClick={handleEdit}
                    />
                    <b> | </b>
                    <FontAwesomeIcon
                      icon={faTrashAlt}
                      style={{ color: 'var(--theme-color-1)' }}
                      cursor="pointer"
                      onClick={toggle}
                    />
                  </div>
                </Colxx>
              </Row>
            </CardTitle>
            <Row>
              <Colxx xxs="12">
                <p>
                  <b>Target: </b>
                  {messageInput.target}
                </p>
                {messageInput.compA && (
                  <p>
                    <b>Compare A: </b>
                    {messageInput.compA}
                  </p>
                )}
                {messageInput.comp && (
                  <p>
                    <b>Equation: </b>
                    {messageInput.comp}
                  </p>
                )}
                {messageInput.compB && (
                  <p>
                    <b>Compare B: </b>
                    {messageInput.compB}
                  </p>
                )}
              </Colxx>
            </Row>
            <Modal isOpen={deleteVisible} toggle={toggle}>
              <ModalHeader toggle={toggle}>
                <span role="img" aria-label="warning">
                  ⚠️
                </span>
                This message will be deleted!
              </ModalHeader>
              <ModalBody>
                <Button color="danger" onClick={() => handleDelete()} size="xs">
                  Delete
                </Button>
                <Button
                  className="ml-2"
                  color="dark"
                  outline
                  size="xs"
                  onClick={toggle}
                >
                  Cancel
                </Button>
              </ModalBody>
            </Modal>
          </Fragment>
        )}
      </CardBody>{' '}
    </Card>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};
export default injectIntl(connect(mapStateToProps)(GoToResponse));
